import { render } from "./decline-form.vue?vue&type=template&id=485218b9&scoped=true"
import script from "./decline-form.vue?vue&type=script&lang=js"
export * from "./decline-form.vue?vue&type=script&lang=js"

import "./decline-form.vue?vue&type=style&index=0&id=485218b9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485218b9"]])

export default __exports__